<template>
    <!-- DESKTOP -->
    <div class="tw-hidden xl:tw-block tw-w-1/2 tw-pr-[6px] 2xl:tw-pr-[10px] tw-shrink-0 tw-h-[295px] 4xl:tw-h-[330px] tw-animate-pulse">
        <div class="tw-w-full tw-h-full tw-bg-[#F2F2F2] dark:tw-bg-[#002039] tw-rounded-[10px]"></div>
    </div>
    <!-- MOBILE -->
    <div class="tw-shrink-0 tw-flex xl:tw-hidden tw-w-[330px] tw-h-[430px] lg:tw-w-1/2 tw-pr-[6px] tw-animate-pulse">
        <div class="tw-w-full tw-h-full tw-bg-[#F2F2F2] dark:tw-bg-[#002039] tw-rounded-[10px]"></div>
    </div>
</template>
<script setup>

</script>
